import React from "react";

import AboutUsHeroSection from "../components/AboutUsComponents/AboutUsHeroSection";
import StoryComponent from "../components/AboutUsComponents/StoryComponent";
import AboutusSection from "../components/AboutUsComponents/AboutusSection";
import WhoWeAre from "../components/AboutUsComponents/WhoWeAre";
import AboutUsNews from "../components/AboutUsComponents/AboutUsNewsSection";

import newsData from "../NewsData/newsData";
import HomeGetInTouch from "../components/HomeComponents/HomeGetInTouch";

const AboutUs = () => {
  return (
    <div style={{width:'100%'}}>
     <AboutUsHeroSection />
      <div style={{display:'flex',flexWrap:'wrap',gap:'20px',padding:'20px',backgroundColor: 'rgb(249, 249, 249)'}}>
          <AboutusSection />
      </div>
        <div style={{padding:'20px'}}>
          <AboutUsNews data={newsData} />
        </div>
     <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
      <StoryComponent />
     </div>
      <WhoWeAre />
      <HomeGetInTouch />
    </div>
  );
};

export default AboutUs;
